"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var Constants = _interopRequireWildcard(require("./constants"));

var _ref;

var _default = new _immutable.Record((_ref = {
  extensionName: null
}, (0, _defineProperty2.default)(_ref, Constants.FOLDER, null), (0, _defineProperty2.default)(_ref, Constants.GENERATED_FROM_LAYOUT_ID, null), (0, _defineProperty2.default)(_ref, Constants.ID, null), (0, _defineProperty2.default)(_ref, "isFromLayout", null), (0, _defineProperty2.default)(_ref, Constants.LABEL, null), (0, _defineProperty2.default)(_ref, Constants.PATH, null), (0, _defineProperty2.default)(_ref, Constants.TEMPLATE_TYPE, null), (0, _defineProperty2.default)(_ref, Constants.TYPE, null), (0, _defineProperty2.default)(_ref, Constants.IS_READ_ONLY, null), _ref), Constants.DESIGN_TEMPLATE);

exports.default = _default;
module.exports = exports.default;